import React from "react";

function PoliticaPrivacidad() {
  return (
    <div style={{ maxWidth: "800px", margin: "40px auto", padding: "20px" }}>
      <h1>Política de Privacidad</h1>
      <p>
        En <strong>Imagy</strong>, valoramos y respetamos la privacidad de nuestros
        usuarios y de los clientes de nuestros clientes. Esta política explica cómo
        recopilamos, usamos y protegemos la información personal.
      </p>
      <h2>1. Información que recopilamos</h2>
      <p>
        Podemos recopilar datos como nombre, número de teléfono, dirección de correo
        electrónico y datos de agenda (turnos, reservas) únicamente con el fin de
        brindar el servicio contratado.
      </p>
      <h2>2. Uso de la información</h2>
      <p>
        La información recopilada se utiliza exclusivamente para enviar notificaciones,
        recordatorios de turnos, confirmaciones o cancelaciones, y para mejorar la
        experiencia del usuario.
      </p>
      <h2>3. Compartición de datos</h2>
      <p>
        No compartimos ni vendemos información personal a terceros. Los datos solo son
        accesibles por el negocio contratante (ejemplo: clínica, peluquería) y por el
        equipo de Imagy para soporte técnico.
      </p>
      <h2>4. Seguridad</h2>
      <p>
        Implementamos medidas de seguridad para proteger la información personal contra
        accesos no autorizados, alteración o divulgación.
      </p>
      <h2>5. Derechos del usuario</h2>
      <p>
        Los usuarios pueden solicitar la modificación o eliminación de sus datos
        comunicándose con nosotros a través de{" "}
        <a href="mailto:contacto@gmail.com">imagina.equipo@imagy.ar</a>.
      </p>
      <h2>6. Cambios en esta política</h2>
      <p>
        Nos reservamos el derecho de actualizar esta política de privacidad en cualquier
        momento. Los cambios se publicarán en esta misma página.
      </p>
      <h2>7. Conservación y eliminación de datos</h2>
        <p>
        En Imagy, los datos de turnos se conservan únicamente mientras son necesarios para la
        gestión de reservas. 
        </p>
        <p>
        Pasado el día del turno, estos se marcan automáticamente como <strong>históricos</strong> 
        y ya no son accesibles para uso normal.
        </p>
        <p>
        Además, realizamos un proceso automático de <strong>eliminación mensual</strong> de
        todos los turnos históricos, asegurando que no almacenamos información personal más
        tiempo del necesario.
        </p>
      <p>Última actualización: Septiembre 2025</p>
    </div>
  );
}

export default PoliticaPrivacidad;
